/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const SubmitCheckoutParams = zod.object({
	sync: zod.boolean()
});

export type SubmitCheckoutParams = zod.input<typeof SubmitCheckoutParams>;
export type SubmitCheckoutParamsOutput = zod.output<typeof SubmitCheckoutParams>;
